import { render } from "./Sandbox.vue?vue&type=template&id=08e3bb3c"
import script from "./Sandbox.vue?vue&type=script&lang=js"
export * from "./Sandbox.vue?vue&type=script&lang=js"

import "./Sandbox.vue?vue&type=style&index=0&id=08e3bb3c&lang=css"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__